module.exports = __webpack_public_path__ + "media/images/hitfun/bg.cup.default-41372066ab863a1dc7e055eb3e8a2fdb.png";